import { useModalStore } from '@/store/modalStore'

export const displayModal = (options) => useModalStore().openModal(options)
